import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    Paper,
    Box,
    Typography,
    Grid,
    TextField,
    Button,
} from '@mui/material';

export default function LeadStatusMaster({
    mode,
    onPopupCancel,
    loggedInUser,
    companyData, connectionString
}) {
    const { id } = useParams();
    const navigate = useNavigate();

    const companyId = companyData?.companyId;
    const fYear = companyData?.financialYear;
    const username = loggedInUser?.emailId;

    const [leadStatus, setLeadStatus] = useState('');
    const [category, setCategory] = useState('');

    useEffect(() => {
        if (mode === 'edit' && id) {
            axios
                .get(`${connectionString}/leadstatus/getDetails/${id}`)
                .then((res) => {
                    setLeadStatus(res.data.LeadStatus || '');
                    setCategory(res.data.Category || '');
                })
                .catch((err) => { console.error('Error fetching lead status:', err); });
        }
    }, [id, mode]);

    const handleCancel = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            navigate('/main/leadStatusDetail');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = { LeadStatus: leadStatus, Category: category, companyId, fYear, username };

        try {
            if (mode === 'add') {
                await axios.post(`${connectionString}/leadstatus/insert`, payload);
                alert('Data inserted successfully');
                setLeadStatus('');
                setCategory('');
            } else {
                await axios.put(`${connectionString}/leadstatus/Update/${id}`, payload);
                alert('Data updated successfully');
            }
            handleCancel();
        } catch (error) {
            console.error('Error inserting/updating lead status:', error);
            alert(`Error ${mode === 'add' ? 'inserting' : 'updating'} data`);
        }
    };

    return (
        <Paper elevation={3} sx={{ maxWidth: 600, mx: 'auto', p: 4 }}>
            <Typography variant="h5" gutterBottom>
                {mode === 'add' ? 'Add Lead Status' : 'Edit Lead Status'}
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Lead Status"
                            required
                            fullWidth
                            size="small"
                            value={leadStatus}
                            onChange={(e) => setLeadStatus(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Category"
                            required
                            fullWidth
                            size="small"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} container justifyContent="center" spacing={2}>
                        <Grid item>
                            <Button type="submit" variant="contained" color="primary">
                                {mode === 'add' ? 'Save' : 'Update'}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" onClick={handleCancel}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}